import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from "react";
import useDeviceInfoProvider from "../hooks/useDeviceInfoProvider";
const DeviceInfoContext = createContext(null);
export const useDeviceInfoContext = () => useContext(DeviceInfoContext);
const DeviceInfoProvider = (props) => (_jsx(DeviceInfoContext.Provider, { ...props, value: useDeviceInfoProvider() }));
export default DeviceInfoProvider;
